import React from 'react';

const Communityscst = () => {
  const committeeMembers = [
    { id: 1, name: "V NAGESWARA RAO", designation: "HOD/EEE", appointedAs: "Convener", mobile: "9848998222" },
    { id: 2, name: "D RAJU", designation: "L/MEC", appointedAs: "Member", mobile: "8125127999" },
    { id: 3, name: "B RAMESH", designation: "HOD/GEN", appointedAs: "Member", mobile: "9492551728" },
    { id: 4, name: "B SOWJANYA", designation: "HOD/CIV", appointedAs: "Member", mobile: "9666326251" },
    { id: 5, name: "BANDI PRAMEELA RANI", designation: "L/CME", appointedAs: "Member", mobile: "9154085414" },
  ];

  const objectives = [
    "To counsel and guide SC, ST and Minority students studying at College on various issues and help them to manage academic and personal demands of a JPKP life effectively.",
    "To ensure provisions for an environment where all such students feel safe and secure.",
    "To provide prompt counseling for any emotional emergencies arising on account of any events at the campus.",
    "To provide a mechanism to redress the grievances of SC, ST and minority students, if any.",
    "To ensure protection and reservation as provided in the constitution of India.",
    "To arrange for special opportunities to enhance the career growth of these students such as through various clubs."
  ];

  return (
    <div className="bg-slate-50 min-h-screen py-10 px-4 sm:px-6 lg:px-8 font-serif">
      <div className="max-w-5xl mx-auto bg-white shadow-2xl rounded-xl overflow-hidden border border-gray-200">
        
        {/* Top Decorative Bar */}
        <div className="h-2 bg-indigo-700 w-full"></div>

        {/* Header Section */}
        <div className="bg-indigo-900 text-white py-12 px-8 text-center relative">
          <h1 className="text-4xl font-bold tracking-tight mb-2">SC/ST & Minority Cell</h1>
          <div className="w-24 h-1 bg-indigo-400 mx-auto rounded-full"></div>
          <p className="mt-4 text-indigo-200 uppercase tracking-[0.2em] text-sm font-semibold">
            Sri Jyothi Polytechnic
          </p>
        </div>

        <div className="p-8 md:p-14 space-y-12">
          
          {/* Introduction Section */}
          <section className="bg-indigo-50/50 p-8 rounded-2xl border border-indigo-100">
            <p className="text-gray-800 leading-relaxed text-lg text-justify first-letter:text-5xl first-letter:font-bold first-letter:mr-3 first-letter:float-left first-letter:text-indigo-900">
              SRI JYOTHI POLYTECHNIC is committed to providing an environment that promotes diversity and respects everyone regardless of colour, religious belief or cultures. While maintaining the diversity of all kinds, it also commits to ensuring the protection of everyone including minorities and acting as per the provisions of the constitution of India in such matters.
            </p>
            <p className="mt-4 text-gray-700 leading-relaxed text-lg">
              In order to create a living and working environment where all students feel safe and respected, there is a need to establish an SC, ST and Minorities Cell with the following objectives:
            </p>
          </section>

          {/* Objectives Grid */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-8 flex items-center">
              <span className="bg-indigo-900 text-white w-8 h-8 rounded-full flex items-center justify-center mr-3 text-sm italic">O</span>
              Cell Objectives
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {objectives.map((obj, index) => (
                <div key={index} className="flex items-start p-5 bg-white border border-gray-100 shadow-sm rounded-xl hover:shadow-md transition-shadow group">
                  <div className="mr-4 mt-1 bg-indigo-100 p-2 rounded-lg group-hover:bg-indigo-900 transition-colors">
                    <svg className="w-4 h-4 text-indigo-900 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-snug">{obj}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Guidelines Section */}
          <section className="border-l-4 border-indigo-900 pl-8 py-2">
            <p className="text-gray-700 italic text-lg leading-relaxed">
              The SC/ ST and Minorities Cell will provide comprehensive preventive and proactive services to all such students enrolled for various academic programmes in the college. The goal of the cell would be to enhance the psychological wellbeing of SC/ ST and Minority students at JPKP so they can take full advantage of the educational opportunities at the college. The guidelines of UGC will be adopted from time to time.
            </p>
          </section>

          {/* Legal Compliance Box */}
          <div className="bg-gray-900 text-white p-6 rounded-xl flex flex-col md:flex-row items-center gap-4">
             <div className="bg-white/10 p-3 rounded-full">
                <svg className="w-8 h-8 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
             </div>
             <p className="text-sm md:text-base font-medium">
                Established as per the <span className="text-indigo-400">Scheduled Castes and the Scheduled Tribes (Prevention of Atrocities Act, 1989 No.33 dated 11/09/1989)</span> as per AICTE norms.
             </p>
          </div>

          {/* Committee Table */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-6 flex items-center uppercase tracking-wider">
               Committee Members
            </h2>
            <div className="overflow-x-auto border border-gray-200 rounded-xl shadow-lg">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-900 text-white uppercase text-xs tracking-widest font-bold">
                    <th className="px-6 py-5 w-20 text-center">S.No</th>
                    <th className="px-6 py-5">Name of the Committee Member</th>
                    <th className="px-6 py-5">Designation</th>
                    <th className="px-6 py-5 text-center">Appointed As</th>
                    <th className="px-6 py-5">Mobile Number</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {committeeMembers.map((member) => (
                    <tr key={member.id} className="hover:bg-indigo-50/50 transition-colors">
                      <td className="px-6 py-5 text-center font-bold text-gray-400">{member.id}</td>
                      <td className="px-6 py-5 font-bold text-gray-900 uppercase tracking-tight">{member.name}</td>
                      <td className="px-6 py-5 text-gray-600 font-medium">{member.designation}</td>
                      <td className="px-6 py-5 text-center">
                        <span className={`px-4 py-1.5 rounded-full text-[11px] font-black uppercase tracking-widest ${
                          member.appointedAs === 'Convener' 
                            ? 'bg-indigo-900 text-white' 
                            : 'bg-indigo-100 text-indigo-900'
                        }`}>
                          {member.appointedAs}
                        </span>
                      </td>
                      <td className="px-6 py-5 text-gray-800 font-mono font-semibold">
                        {member.mobile}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 p-6 border-t border-gray-200 text-center text-xs text-gray-400 font-medium">
          © {new Date().getFullYear()} SRI JYOTHI POLYTECHNIC - CELL FOR SC/ST & MINORITIES
        </div>
      </div>
    </div>
  );
};

export default Communityscst;